import React from 'react';
import { Typography, Button, Container, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import { LockOutlined } from '@mui/icons-material';

export const UnauthorizedPage: React.FC = () => {
    return (
        <Container maxWidth="sm" sx={{ mt: 8 }}>
            <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                <LockOutlined color="error" sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h4" component="h1" gutterBottom>
                    Access Denied
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                    You don't have permission to access this page. This area is restricted.
                </Typography>
                <Button
                    component={Link}
                    to="/timesheetList"
                    variant="contained"
                    color="primary"
                >
                    Go to Home
                </Button>
            </Paper>
        </Container>
    );
};